import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ROUTES } from '../../../config/routes';
import { products } from '../../product-catalog/productPresentation';
import ContentAction from '../shared/ContentAction';
import ProductCard from './ProductCard';
import './ProductOverviewPage.css';

export default function ProductIntroPage() {
  const { t } = useTranslation('app');
  const copy = key => t(`productIntro.main.${key}`);
  useEffect(() => { document.title = 'Hi-Portal'; }, []);
  return (
    <main className="product-intro-page">
      <section className="product-intro-hero">
        <div className="product-intro-hero-decoration product-intro-hero-decoration-one" />
        <div className="product-intro-hero-decoration product-intro-hero-decoration-two" />
        <div className="product-intro-container product-intro-hero-inner">
          <span className="product-intro-eyebrow">
            {copy('hero.eyebrow')}
          </span>
          <h1>
            {copy('hero.title')}
          </h1>
          <p>
            {copy('hero.description')}
          </p>
        </div>
      </section>
      <section className="product-intro-products">
        <div className="product-intro-container">
          <div className="product-intro-section-heading">
            <span>
              {copy('products.eyebrow')}
            </span>
            <h2>
              {copy('products.title')}
            </h2>
            <p>
              {copy('products.description')}
            </p>
          </div>
          <div className="product-intro-grid">
            {products.map((product, index) => <ProductCard key={product.id} product={product} number={index + 1} />)}
          </div>
        </div>
      </section>
      <section className="product-intro-bottom">
        <div className="product-intro-container">
          <div className="product-intro-bottom-content">
            <div>
              <span>{copy('bottom.eyebrow')}
              </span>
              <h2>{copy('bottom.title')}
              </h2>
              <p>{copy('bottom.description')}
              </p>
            </div>
            <ContentAction action={{ href: ROUTES.resources }}>
              {copy('actions.resources')}
              <span>→
              </span>
            </ContentAction>
          </div>
        </div>
      </section>
    </main>
  );
}
